import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { ModelToView } from '@doger/core/modules/chat';
import type { SessionResponse } from '@doger/core/shared/api';

import type { AIModel } from './model-to-view.representation';
import styles from './current-model.module.scss';

export type CurrentModelProps = {
  session: SessionResponse;
  className?: string;
};

export const CurrentModel = ({ session, className }: CurrentModelProps) => {
  const { t } = useTranslation('core');

  if (!session) {
    return null;
  }

  const currentModel = session.appName as AIModel;

  // const isCustomTitle =
  //   !!session.state?.title || session.meta.title !== ChatConfig.DEFAULT_TITLE;

  return (
    <div className={clsx(styles.header, className)}>
      <div className={styles.model}>
        <span className={styles.label}>{t('chat.model.label')}</span>
        <span className={styles.value}>
          {ModelToView.toView(currentModel).name}
        </span>
      </div>

      {/* {isCustomTitle && (
        <div className={styles.titleContainer}>
          <span className={styles.title}>{session.meta.title}</span>
        </div>
      )} */}
    </div>
  );
};
